import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { FixedLengthArray, ValueOf } from 'type-fest';

import { makeAPIRequestReactQuery } from './api';

export const useConfidenceThresholds = (
  options?: UseQueryOptions<
    TConfidenceThresholds,
    unknown,
    TConfidenceThresholds,
    ['analyses', 'confidenceThresholds']
  >,
) => {
  return useQuery(
    ['analyses', 'confidenceThresholds'],
    () =>
      makeAPIRequestReactQuery<TConfidenceThresholds>(
        `analyses/confidenceThresholds`,
        undefined,
        'get',
      ),
    options,
  );
};

const ConfidenceThresholdLabels = {
  calculus: 'calculus',
  caries: 'caries',
  periapicalRadioLucency: 'periapicalRadiolucency',
  restorationAdjacentLucency: 'restorationAdjacentLucency',
} as const;
type TConfidenceThresholdLabels = ValueOf<typeof ConfidenceThresholdLabels>;

type TConfidenceThresholds = {
  label: TConfidenceThresholdLabels;
  confidenceThresholds: FixedLengthArray<number, 8>;
}[];
